// i18n
import { i18n } from '@ecg-internal/js-react-i18n';
import { fr as dateLocale } from 'date-fns/locale/fr';
import translation from '../../../../locales/fr-BE/translation.json';
import common from '../../../../locales/fr-BE/common.json';

export default i18n.init({
  lng: 'fr-BE',
  translations: {
    translation,
    common,
  },
  dateLocale,
});
